@if (chatReady()) {
<vatutor-chat
    #chat
    [env]="resolvedEnv()"
    [token]="token()"
    [intro]="intro()"
    [standalone]="standalone()"
    [assistantSubtitle]="'Assistente Virtuale'"
    [language]="'it'"
    [userType]="userType()"
    [userName]="userInfo()?.name"
    [courseId]="courseId()"
    [subTenantName]="subTenantName()"
    [closed]="chatClosed()"
    [dialog]="dialog()"
></vatutor-chat>
} @else {
<div style="display:flex;align-items:center;justify-content:center;height:100%;color:#999">
    Loading chat...
</div>
}
